import type { JobPostingSkillFragment } from '@xing-com/crate-jobs-graphql';
import type { JobDetails, Preference } from '@xing-com/crate-jobs-helpers';
import { useExperiment } from '@xing-com/hub';

import { JobsXingletWrapper } from '../../../jobs-xinglet';
import type { XingletInterface } from '../../../jobs-xinglet';

import { ExperimentalMatchingSkillsSkeleton } from './experimental-matching-skills';
import { MatchingSkillsSkeleton } from './matching-skills-skeleton';

export type MatchingSkillsProps = {
  job: JobDetails;
  matchedPreferences?: Preference[];
  matchedSkills?: JobPostingSkillFragment[];
  notMatchedSkills?: JobPostingSkillFragment[];
};

export type MatchingSkillsXinglet = XingletInterface<MatchingSkillsProps>;

const CurrentMatchingSkills = JobsXingletWrapper<MatchingSkillsProps>(
  '@xing-com/crate-jobs-domain-job-details-matching-skills',
  <MatchingSkillsSkeleton />
);

const ExperimentalMatchingSkills = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-job-details-matching-skills-experiment',
  <ExperimentalMatchingSkillsSkeleton />
);

export const MatchingSkills: React.FC<MatchingSkillsProps> = (props) => {
  const isExperimentalVariant = useExperiment('ABACUS-572') === 'B';

  if (isExperimentalVariant) {
    return <ExperimentalMatchingSkills />;
  }

  return <CurrentMatchingSkills {...props} />;
};
